var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRoomSceneryWindow({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 68,
    height: 116,
    viewBox: "0 0 68 116",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D7D7D7",
    d: "M9.118 72H32V42H9.118v30zm0 5v30H32V77H9.118zM60 72V42H37v30h23zm0 5H37v30h23V77zM9.118 37H32V9H9.118v28zM60 37V9H37v28h23zM0 0h68v116H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#F4F4F4",
    d: "M32.5 72.5H8.618v-31H32.5v31zm-23.882 35v-31H32.5v31H8.618zm51.882-66v31h-24v-31h24zm-24 35h24v31h-24v-31zm-4-39H8.618v-29H32.5v29zm28-29v29h-24v-29h24zM.5.5v115h67V.5H.5z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRoomSceneryWindow);
export default __webpack_public_path__ + "static/media/RoomSceneryWindow.aa3fa451e206343c472accfa907d108e.svg";
export { ForwardRef as ReactComponent };